<div class="w-full text-center flex items-center justify-center">
	<div class="text-center mb-4 flex gap-4 items-center">
		<p class="text-2xl font-bold">Order summary</p>
		<p
			class="cursor-pointer hover:text-green"
			(click)="editPolicyDetails()"
			[testHook]="testHooks.EditPolicyDetailsParagraph"
		>
			<app-icon [icon]="ICON.EDIT"></app-icon> Edit policy details
		</p>
	</div>
</div>
<div class="mt-3 max-w-3xl mx-auto w-full flex justify-center items-center">
	<div class="w-full flex justify-between items-center">
		<div class="flex items-center gap-2">
			<p class="text-grey">Order number</p>
			<p class="font-bold text-lg">{{ orderNumber$ | async }}</p>
		</div>
		<div class="h-6 border-l border-grey-veryLight"></div>
		<div class="flex items-center gap-2">
			<p class="text-grey">Order date</p>
			<p class="font-bold text-lg">
				{{ orderedOn$ | async | date: 'mediumDate' }}
			</p>
		</div>
		<div class="h-6 border-l border-grey-veryLight"></div>
		<div class="flex items-center gap-2">
			<p class="text-grey">Effective date</p>
			<p class="font-bold text-lg">
				{{ effectiveDate$ | async | date: 'mediumDate' }}
			</p>
		</div>
	</div>
</div>
<div class="flex flex-col lg:flex-row gap-10 mt-10">
	<div class="lg:w-2/3 flex flex-col gap-4">
		<div class="flex flex-col gap-2">
			<div class="flex gap-2 items-center">
				<p class="font-bold text-lg">Total amount</p>
			</div>
			<div class="border border-grey-lighter rounded-md p-2">
				<div
					class="flex justify-between items-center 2xl:pr-40 2xl:pl-20 xl:pr-20 xl:pl-10"
				>
					<h2 class="text-green">
						{{ amountDueByClient$ | async | centsToDollars }}
					</h2>
					<div class="h-12 border-l border-grey"></div>
					<div class="relative">
						<p class="text-gray-600">Premium</p>
						<div class="flex items-center gap-4">
							<p class="font-bold">
								{{ (premium$ | async) || 0 | centsToDollars }}
							</p>
							<app-icon
								[class]="'w-fit cursor-pointer ' + premiumPillData.iconClass"
								[icon]="premiumPillData.icon"
								(click)="togglePill('premium')"
								[testHook]="testHooks.TogglePillIcon"
							></app-icon>
							<div
								*ngIf="displayPill === 'premium'"
								class="text-sm absolute -bottom-4 -right-24 bg-white border py-1 px-2 rounded-xl z-50 flex items-start justify-between"
							>
								<div>
									<app-icon
										[icon]="premiumPillData.icon"
										[class]="premiumPillData.iconClass"
									></app-icon>
									<span>{{ premiumPillData.text }}</span>
								</div>
								<app-icon
									class="cursor-pointer"
									[icon]="ICON.CLOSE"
									(click)="togglePill('none')"
									[testHook]="testHooks.TogglePillIcon1"
								></app-icon>
							</div>
						</div>
					</div>
					<div class="relative">
						<p class="text-gray-600">Counsel credit</p>
						<div class="flex items-center gap-4">
							<p class="font-bold">
								{{ (counselCredit$ | async) || 0 | centsToDollars }}
							</p>
							<app-icon
								[class]="'w-fit cursor-pointer ' + counselPillData.iconClass"
								[icon]="counselPillData.icon"
								(click)="togglePill('counsel')"
								[testHook]="testHooks.TogglePillIcon2"
							></app-icon>
							<div
								*ngIf="displayPill === 'counsel'"
								class="gap-4 text-sm absolute -bottom-4 -right-24 bg-white border py-1 px-2 rounded-xl z-50 flex items-start justify-between"
							>
								<div>
									<app-icon
										[icon]="counselPillData?.icon"
										[class]="counselPillData?.iconClass"
									></app-icon>
									<span class="ml-3">{{ counselPillData?.text }}</span>
								</div>
								<app-icon
									class="cursor-pointer"
									[icon]="ICON.CLOSE"
									(click)="togglePill('none')"
									[testHook]="testHooks.TogglePillIcon3"
								></app-icon>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<app-title-insurance-policies
			[disabled]="true"
		></app-title-insurance-policies>
	</div>
	<app-title-insurance-documents
		class="lg:w-1/3"
		type="dropzone"
		[disabled]="true"
		[showCommercialForm]="true"
	></app-title-insurance-documents>
</div>
